var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "url(#paint0_linear_7214_608)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.78987 14.8417C11.1627 12.9365 14.0786 11.6805 15.5375 11.0737C19.7032 9.34102 20.5688 9.04004 21.133 9.0301C21.257 9.02792 21.5345 9.05867 21.7142 9.2045C21.866 9.32763 21.9077 9.49397 21.9277 9.61072C21.9477 9.72746 21.9725 9.99341 21.9528 10.2012C21.727 12.5731 20.7503 18.3289 20.2533 20.9854C20.0431 22.1095 19.6291 22.4864 19.2282 22.5233C18.3572 22.6034 17.6957 21.9476 16.852 21.3946C15.5318 20.5292 14.786 19.9905 13.5045 19.146C12.0235 18.1701 12.9836 17.6337 13.8276 16.757C14.0485 16.5276 17.8865 13.0367 17.9608 12.72C17.97 12.6804 17.9787 12.5328 17.891 12.4548C17.8032 12.3769 17.6738 12.4035 17.5804 12.4247C17.448 12.4548 15.3389 13.8488 11.2533 16.6067C10.6547 17.0177 10.1124 17.218 9.62661 17.2075C9.09103 17.196 8.0608 16.9047 7.29492 16.6558C6.35555 16.3504 5.60895 16.189 5.67396 15.6704C5.70782 15.4003 6.07979 15.124 6.78987 14.8417Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7214_608",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 29.7775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CA4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D83BF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.9420253ce0cbafd63817b1a26b9abe14.svg";
export { ForwardRef as ReactComponent };